import React from 'react'
import axios from 'axios';
import { useRef } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Logo from './img/logo/TC-LOGO.png';
import './SignIn.css';

function SignInAdmin() {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [counter, setCounter] = useState(0);
  const history = useHistory();

  function useInterval(callback, delay) {

    const savedCallback = useRef();
  
    // Remember the latest callback.
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);
  
    // Set up the interval.
    useEffect(() => {
      let id = setInterval(() => {
        savedCallback.current();
      }, delay);
      return () => clearInterval(id);
    }, [delay]);

    
  }

  useInterval(() => {
    setCounter(counter + 1);
  }, 1000);

  useEffect(() => {
    if(counter === 5){
        document.getElementById("307").style.display = "none";
        document.getElementById("707").style.display = "none";
    }
  }, [counter])

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  const onSubmit = () => {

    if(!isValidEmail(email)){
        document.getElementById("307").style.display = "block";
        document.getElementById("__307").style.border = "1px solid red";
        setCounter(0);

    }else if(password === ''){
        document.getElementById("707").style.display = "block";
        document.getElementById("__707").style.border = "1px solid red";
        setCounter(0);
    }else{
    
        axios
            .get('https://toycityzimbabwe.com/backend/auth.php',{params: { email, password}} )
            .then(res => {
                validUser(res.data)
            })
            .catch( error => {
                console.log(error)
            });
    }
  }

  function validUser(user){

    if(user.length === 0){
        document.getElementById("909").style.display = "block";
    }else{
        history.push('/Admin14F-efghS=workApp/filesManagement-Wdf17/Admin');
    }
  }

  return (
    <div className='signin'>
        <div className='signin_logo'>
            <Link to='/'>
                <img className='logo' src={Logo}/>
            </Link>    
        </div>
        <div className='signin_text'>
            <h2>Sign In</h2>
            <h3>Login to your Toy City  Admin Account</h3>
        </div>
        <div className='signin__blueSide'>
        </div>
        <div className='signin__center'>
            <input type="text" id='__307' value={email} onChange={e => setEmail(e.target.value)} placeholder="Email"></input>
            <div className='signin__error' id='307'><label id='424'>Email invalid</label></div>
            <input type="password" id='__707' value={password} onChange={e => setPassword(e.target.value)} placeholder="Password"></input>
            <Link to='/changepassword'><div className='signin__forgot'><label className='signin_goto'>Forgot Password?</label></div></Link>
            <div className='signin__error' id='707'><label id='424'>Password required</label></div>
            <div className='signin__error' id='909'><label id='424'>Password or email incorrect</label></div>
            <button onClick={onSubmit}>Sign In</button>
        </div>
    </div>
  )
}

export default SignInAdmin;